module.exports = __webpack_public_path__ + "img/thumbnail_video_preview.f995e33d.png";